import React from "react";
import "./index.css";

const Container = ({ children }: { children?: React.ReactNode }) => {
  return (
    <div className="container" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {children}
      </div>
    </div>
  );
};

export default Container;
